import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUploadedComponent } from './simple-icons-uploaded.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUploadedComponent ],
    exports:      [ SimpleIconsUploadedComponent ],
    bootstrap:    []
})
export class SimpleIconsUploadedModule {}
